import React from 'react';
import PropTypes from 'prop-types';
import tc from 'tinycolor2';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';

import { colors, typography } from '../../styles';


const styles = css`
  display: block;
  width: 100%;
  margin: 0;
  padding: 20px 0;
  color: #FFFFFF;
  .OutDoorRec_wrapper{
    background-color: ${tc(colors.color4).lighten(17).toString()};
    margin: auto;
    padding: 20px;
    @media(min-width:992px){
      padding: 40px;
      &:nth-child(odd){
        .OutDoorRec_imageWrapper{
          order:2;
          @media(min-width:768px){
            margin:0 0 0 20px;
          }
        }
        .OutDoorRec_contentWrapper{
          order:1;
        }
      }
    }
  }
  .OutDoorRec_header{
    font-family: ${typography.SerifHead};
    font-weight: bold;
    letter-spacing: 0.62px;
    font-style: italic;
  }
  .OutDoorRec_title{
    font-size: 16px;
    font-style: italic;
  }
  .OutDoorRec_cost{
    font-weight: bold
  }
  .OutDoorRec_body{
    font-weight: 300;
    font-size: 16px;
    color: #FFFFFF;
    letter-spacing: 0;
    line-height: 30px;
    text-align: left;
    @media(min-width: 992px) {
      font-size: 18px;
      line-height: 26px;
    }

    @media(min-width: 1600px) {
    }
  }
  .OutDoorRec_imageWrapper{
    margin-bottom:20px;
    margin:0 20px 0 0;
  }
  .OutDoorRec_image{
    width:100%;
    @media(min-width: 768px){
      max-width: 400px;
      min-width:400px;
    }
  }
    font-family: ${typography.SerifHead};
  .OutDoorRec_sectionTitle{
    display: block;
    width: 100%;
    font-family: ${typography.SansSerif};
    font-weight: 300;
    font-size: 24px;
    letter-spacing: 0;
    @media(min-width: 768px) {
      font-size: 30px;
    }
    @media(min-width: 992px) {
      font-size: 35px;
    }
    @media(min-width: 1200px) {
      font-size: 40px;
    }
  }
`;


function OutDoorRec({ content }) {
  return (
    <div className={styles}>
      <div className="container">
        <h3 className="OutDoorRec_sectionTitle GoldText Underdog_center text-center">Outdoor Recreation</h3>
        {
          content.map(item => (
            <div key={item._id} className="OutDoorRec_wrapper mb-2 d-flex flex-column flex-md-row">
              <div className="OutDoorRec_imageWrapper">
                <Image className="OutDoorRec_image" src={item.image.contentUrl} alt={item.title} />
              </div>
              <div className="OutDoorRec_contentWrapper">
                {item.title &&
                  <h3 className="OutDoorRec_header GoldText mr-3">{item.title}</h3>
                }
                <div className="OutDoorRec_body" dangerouslySetInnerHTML={SanitizeHtml(item.info)} />
              </div>
            </div>
          ))
        }
      </div>
    </div>
  );
}
OutDoorRec.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default(OutDoorRec);



// WEBPACK FOOTER //
// ./src/pages/Overview/OutDoorRec.js